<template>
  <div class="cc-wrapper">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
/* global Chart */

/**
 * Gráfico de linhas com várias séries de dispositivos diferentes.
 *
 * Cada unidade ganha o seu próprio eixo Y (L/h, °C, hPa...), alternando esquerda e
 * direita. Assim vazão e temperatura aparecem juntas sem normalizar para 0–100, que
 * esconde o valor real e estoura quando passa do teto fixo.
 */
export default {
  name: "ComparacaoChart",
  props: {
    // [{ id, label, color, unit, values: [24 valores ou null, índice = hora] }]
    series: { type: Array, default: () => [] },
  },
  data() {
    return { chart: null };
  },
  watch: {
    series: {
      handler() { this.render(); },
      deep: true,
    },
  },
  mounted() {
    this.render();
  },
  beforeUnmount() {
    if (this.chart) this.chart.destroy();
  },
  methods: {
    render() {
      if (this.chart) {
        this.chart.destroy();
        this.chart = null;
      }
      if (!this.$refs.canvas || !this.series.length) return;

      const unidades = [...new Set(this.series.map((s) => s.unit))];
      const labels = Array.from({ length: 24 }, (_, h) => `${String(h).padStart(2, "0")}:00`);

      const datasets = this.series.map((s) => ({
        label: s.legenda || s.label,
        data: s.values,
        yAxisID: s.unit,
        borderColor: s.color,
        backgroundColor: s.color,
        fill: false,
        borderWidth: 2,
        pointRadius: 2,
        spanGaps: true,
        lineTension: 0.2,
      }));

      const yAxes = unidades.map((u, i) => ({
        id: u,
        position: i % 2 === 0 ? "left" : "right",
        scaleLabel: { display: true, labelString: u, fontColor: "#666", fontSize: 11 },
        ticks: { fontColor: "#999", fontSize: 10 },
        // Só o primeiro eixo desenha a grade; os demais poluiriam o fundo.
        gridLines: { color: "#e8e8e8", drawOnChartArea: i === 0 },
      }));

      this.chart = new Chart(this.$refs.canvas, {
        type: "line",
        data: { labels, datasets },
        options: {
          animation: { duration: 300 },
          responsive: true,
          maintainAspectRatio: false,
          // Legenda desenhada pela página (mais curta, sem repetir o dispositivo).
          legend: { display: false },
          tooltips: {
            mode: "index",
            intersect: false,
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            titleFontColor: "#333",
            bodyFontColor: "#333",
            borderColor: "#ddd",
            borderWidth: 1,
            callbacks: {
              label: (item, data) => {
                const ds = data.datasets[item.datasetIndex];
                const v = item.yLabel;
                return `${ds.label}: ${v == null ? "--" : Number(v).toLocaleString("pt-BR", { maximumFractionDigits: 2 })} ${ds.yAxisID}`;
              },
            },
          },
          scales: {
            yAxes,
            xAxes: [{ ticks: { fontColor: "#999", fontSize: 10, maxRotation: 0 }, gridLines: { display: false } }],
          },
        },
      });
    },
  },
};
</script>

<style scoped>
.cc-wrapper {
  position: relative;
  height: 260px;
}
</style>
